import { render, staticRenderFns } from "./UsuariosPorComercioTable.vue?vue&type=template&id=a5369fca&scoped=true&"
import script from "./UsuariosPorComercioTable.vue?vue&type=script&lang=js&"
export * from "./UsuariosPorComercioTable.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPorComercioTable.vue?vue&type=style&index=0&id=a5369fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5369fca",
  null
  
)

export default component.exports